import React from 'react';
import TipOfTheDayPosts from '../components/tipOfTheDay';
import baiBannerImgCn from '../images/tip-of-the-day/bai-cn-728x90.png';
import baiBannerImgEn from '../images/tip-of-the-day/bai-en-728x90.png';
import Logo from '../components/logo';
import Seo from '../components/seo';

const chineseLocales = new Set(['zh_cn', 'zh_tw']);

const TipOfTheDay = ({ pageContext: { locale } }) => {
    const baiBannerImg = chineseLocales.has(locale) ? baiBannerImgCn : baiBannerImgEn;

    return (
        <div className="container mt-5">
            <div className="tip-top-banner text-center py-3">
                <a className="pointer" href="https://chat.b.ai/chat?utm_source=bt" target="_blank" rel="noopener noreferrer">
                    <img src={baiBannerImg} alt="bai" className="img-fluid" />
                </a>
            </div>
            <div className="row align-items-start mt-3">
                <div className="col-md-8 pt-4 pr-5">
                    <Logo
                        color="black-bt"
                        tag="p"
                        productName="Tip of the Day"
                        className="text-center text-md-left mb-5"
                        fsMax={21.5}
                    />
                    <TipOfTheDayPosts />
                </div>
            </div>
        </div>
    );
};

export default TipOfTheDay;

export const Head = ({ pageContext }) => <Seo pageContext={pageContext} />;
